// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "-legacy." + {"214":"3f42051c","348":"249e851c","511":"903e952e","700":"04693457","702":"eabb88dc","728":"35c1e4bd","748":"ab450d6f","789":"5fd3fb46","908":"635db0d7","912":"42cf3a90","955":"a53989d6"}[chunkId] + ".js";
};